module.exports = __webpack_public_path__ + "static/media/VerizonNHGDS-Italic.b5dd7030.ttf";